<div class="adx-lib-widget-setting-wrapper">
    <div class="adx-settings-dialog">
        <div class="adx-settings-header">
            <h2 class="adx-settings-title">
                {{ "OICL_OPENBRIDGE.COMPASS.WIDGET.COMPASS" | translate }} {{ "OICL_OPENBRIDGE.COMPASS.WIDGET.SETTINGS" | translate }}
            </h2>
            <button mat-icon-button
                    [mat-dialog-close]="true"
                    aria-label="Close Button"
                    class="adx-settings-close-btn">
                <fa-icon [icon]="'xmark'"></fa-icon>
            </button>
        </div>

        <div class="adx-settings-content">
            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ "OICL_OPENBRIDGE.COMPASS.WIDGET.TITLE" | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="widgetTitle">
                </mat-form-field>
            </div>

            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ 'OICL_OPENBRIDGE.COMPASS.WIDGET.WIDGET_HEADER_DISPLAY_OPTIONS' | translate }}</mat-label>
                    <mat-select [(value)]="selectedWidgetHeaderOption" (selectionChange)="selectHeaderOption($event)">
                        @for (option of (openBridgeCompassWidget.settings.widgetHeader | keyvalue); track option.key) {
                            <mat-option [value]="option.key" [disabled]="option.key === 'alwaysOff' || option.key === 'transparent'">
                                {{ getText(option.key) }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="adx-form-row adx-toggle-row">
                <mat-slide-toggle class="primary" [(ngModel)]="showWidgetTitle">
                    <span class="adx-toggle-label">{{ 'OICL_OPENBRIDGE.COMPASS.WIDGET.SHOW_WIDGET_TITLE' | translate }}</span>
                </mat-slide-toggle>
            </div>

            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ "OICL_OPENBRIDGE.COMPASS.WIDGET.MMSI" | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="selectedEntityIdPattern">
                </mat-form-field>
            </div>
        </div>

        <div class="adx-settings-footer">
            <button mat-raised-button
                    type="button"
                    [mat-dialog-close]="true">
                {{ "OICL_OPENBRIDGE.COMPASS.WIDGET.CANCEL" | translate }}
            </button>
            <button mat-raised-button
                    class="primary"
                    type="submit"
                    (click)="onSubmit()">
                {{ "OICL_OPENBRIDGE.COMPASS.WIDGET.SAVE" | translate }}
            </button>
        </div>
    </div>
</div>
